module.exports = __webpack_public_path__ + "img/gaconfecciones.b5173769.png";